import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { formatDateTime } from '@cp/src/utils/commonUtils';
import { Avatar, Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import styles from '../../index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { useNavigate } from 'react-router-dom';
import { PENDING_APPROVALS_KEY, initialPaginationParams } from '../../constant';
import {
  setCurrentSelectedPanIndex,
  setSelectedPanApprovalItem
} from '../../reducers/ApprovalsSlice';
import { IPendingApprovalItem } from '../../interface';

const PendingPanApprovalListItem = (props: {
  approvalItem: IPendingApprovalItem;
  index: number;
}) => {
  const { approvalItem, index } = props;
  const selectedApprovalItem = useSelector(
    (state: RootState) => state.approvals.selectedPanApprovalItem
  );
  const createdAt = approvalItem?.createdAt;
  const { agentName, optimizedSelfieDocumentUri } = approvalItem?.data || {};
  const { [PENDING_APPROVALS_KEY]: queryParams } = readQueryParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSelectApprovalItem = () => {
    dispatch(setCurrentSelectedPanIndex(index));
    dispatch(setSelectedPanApprovalItem(approvalItem));
    const params = {
      ...initialPaginationParams,
      ...queryParams
    };
    const url = createQueryParams({ [PENDING_APPROVALS_KEY]: params });
    navigate(url, {
      replace: true
    });
  };

  return (
    <div
      className={cx([
        styles.listItem,
        {
          [styles.listItem__active]: approvalItem?.referenceId === selectedApprovalItem?.referenceId
        }
      ])}
      onClick={handleSelectApprovalItem}
    >
      <Avatar src={optimizedSelfieDocumentUri} isImage size={36} />
      <div>
        <span title={agentName}>
          <Typography className={styles.sideBarName} variant={'p3'}>
            {agentName}
          </Typography>
        </span>
        <Typography variant={'p5'} className={styles.timestamp}>
          {formatDateTime(createdAt)}
        </Typography>
      </div>
    </div>
  );
};

export default PendingPanApprovalListItem;
